import './chat.css';
import React, { useState, useEffect, useRef } from 'react';
import chatBG from'../../images/chatBG.png'
import {IsLSWork} from '../app/app'
import { audio, ambient, musicContinue, musicContinueSwitch, playMusic, pauseMusic, setVolume, transitionVolume, stopMusic, isPlaying, playEffects, setVolumeEffects, stopEffects, transitionVolumeEffects, isPlayingEffects, playAmbient, setVolumeAmbient, transitionVolumeAmbient, stopAmbient} from '../musicEngine/musicEngine';
import notificationSound from'../../m/notification.js'
import messageSound from'../../m/message.js'
import messageSent from'../../m/messageSent.js'
import whoosh from'../../m/whoosh.js'

function Chat({mess, from, state, step, goNext, goMenu, setFailedGame, gallery, setGallery, mainPisi, pChoise, gallerySC, goNextOnI, language, hzAdjuster}) {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [save, setSave] = useState(0);
  const [messages, setMessage] = useState([]);
  const [answers, setAnswers] = useState();
  const [myAnswers, setMyAnswers] = useState([]);
  const [opacity, setOpacity] = useState("none");
  const [white, setWhite] = useState(1);
  const [messNum, setMessNum] = useState(0);
  const [value, setValue] = useState();
  const [failer, setFailer] = useState();
  const [choise, setChoise] = useState();
    const [next, setNext] = useState();
    const [nextOnI, setNextOnI] = useState();
    const [indexWrap, setIndexWrap] = useState(20);
    const [answArr, setAnswArr] = useState(["NSFW","Normal","Other"]);
    const [moveTo, setMoveTo] = useState();
    let savedAnswers = useRef(new Array());
    let chatCompleted = useRef(false);
    let answersAppeared = useRef(false);
  let answered, newGallery;
  const answer0 = useRef(null)
  const answer1 = useRef(null)

  let textTranslation = {
    en:{
      online:"Online",
    },
    ru:{
      online:"В сети",
    }
  }

  useEffect(() => {
     newGallery = new Map(gallery);
  });

  useEffect(() => {
    document.addEventListener('deviceready', deviceReadyFunc, false);
    function deviceReadyFunc() {
      document.addEventListener('backbutton', onBackButton, false);
    }
    function onBackButton(e) {
      e.preventDefault();
      goToMenu();
    }
    return () => {
      document.removeEventListener('deviceready', deviceReadyFunc, false);
      document.removeEventListener('backbutton', onBackButton, false);
    }
  },[]);

  useEffect(() => {
    if(state.current[step] == undefined){
      state.current.splice(step, 1, {chat:true, completed:chatCompleted.current, savedAnswers:JSON.stringify([])})
      if(isLS){
      localStorage.setItem('stateSC1', JSON.stringify(state.current));
    }
    }
    if(state.current[step]["completed"]){
      chatCompleted.current = state.current[step]["completed"];
    }else{
      chatCompleted.current = false;
    }
    if(state.current[step]["savedAnswers"]){
       savedAnswers.current = JSON.parse(state.current[step]["savedAnswers"]);
    }else{
      savedAnswers.current = [];
    }
    start(messNum);
    changeWhite(true);
},[]);

useEffect(() => {
  var d = document.getElementById('messages');
if(d.scrollHeight > d.clientHeight) {
d.scrollTop = d.scrollHeight - d.clientHeight;
}
});

useEffect(() => {
    state.current.splice(step, 1, {chat:true, completed:chatCompleted.current, savedAnswers:JSON.stringify(savedAnswers.current)})
    if(isLS){
    localStorage.setItem('stateSC1', JSON.stringify(state.current));
  }
},[save]);

async function go(){
  chatCompleted.current = true;
  setSave(previous => previous + 1)
  setIndexWrap(20);
  playEffects(whoosh, false);
  await changeWhite();
  goNext();
}

async function goOnI(){
  setIndexWrap(20);
  playEffects(whoosh, false);
  await changeWhite();
  if(moveTo === undefined){
    goNextOnI(3);
  }else{
    goNextOnI(moveTo);
  }
}

async function goToMenu(){
  setIndexWrap(20);
  playEffects(whoosh, false);
  await changeWhite();
  goMenu();
}
function changeWhite(toLow){
  return new Promise((resolve, reject) => {
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
  if(toLow){
    if(op>0){
      op-=0.03;
    setWhite(op);
    setTimeout(ChangetoLow, 10);
  }else{
    resolve();
    setIndexWrap(14);
    return;
  }
}else{
  if(op<1){
    op+=0.03;
  setWhite(op);
  setTimeout(change, 10);
}else{
  resolve();
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
});
}

const onChange = (e) => {
  setValue(e.target.value);
};

async function myAnswer(e){
  if(answersAppeared.current){
    await ans();
  }else{return}

  function ans(){
        return new Promise(async (resolve, reject) => {
            setIndexWrap(18);
            //changeOpacity(true);
            let input = e.target.outerHTML;
            let name = input.split('name="')[1];
            name = name.split('"')[0];
            setVolumeEffects(0.05);
            playEffects(messageSent, false);
            await changeSetting(eval("answer"+name),"current.style.transform", document.body.clientWidth*-0.1, "translateX", 3);
            await changeSetting(eval("answer"+name),"current.style.transform", document.body.clientWidth, "translateX", 20);
            if(name == 0){
              name=1;
            }else{
              name=0;
            }
            await changeSetting(eval("answer"+name),"current.style.transform", document.body.clientWidth*0.1, "translateX", 6);
            await changeSetting(eval("answer"+name),"current.style.transform", -document.body.clientWidth, "translateX", 25);
            setOpacity("none");
            answersAppeared.current = false;
            if(input.includes('value="') === true){
              let preAns = input.split('value="')[1];
              preAns = preAns.split('"')[0];
              setMessage([...messages, {text:preAns, from: 'messageFromMe'}]);
              answered=preAns;
            }
            /*
            if(!e.target.src && e.target.innerHTML.indexOf("<img src=") === -1){
            setMessage([...messages, {text:e.target.innerHTML, from: 'messageFromMe'}]);
            answered=e.target.innerHTML;
          }else{
            if(e.target.src){
              setMessage([...messages, {img:e.target.src, height:"300px", from: 'messageFromMe'}]);
              answered="/static" + e.target.src.split("/static")[1];
          }else{
            setMessage([...messages, {img:e.target.childNodes[0].src, height:"300px", from: 'messageFromMe'}]);
            answered="/static" + e.target.childNodes[0].src.split("/static")[1];
          }
        }*/
            start(messNum);
            resolve();
          });
        }
}

function waitin(){
  return new Promise((resolve, reject) => {
    document.getElementById("wrap").onclick=ff;
function ff(){
  resolve();
}
  });
}

async function start(startingFrom){
  for(let i=startingFrom;i<mess.length;i++){
    if(mess[i].answered){
            if(answered !== undefined && answered.indexOf("/static/media/") !==-1){
      answered = answered.split("/static/media/")[1];
      }
      if(mess[i].answered.indexOf("/static/media/") !==-1){
      mess[i].answered = mess[i].answered.split("/static/media/")[1];
      }
      if(answered !== mess[i].answered){
        if(mess[i].endofAnswer){
          answered=undefined;
        }
        continue;
      }
      if(mess[i].endofAnswer){
        answered=undefined;
      }
    }
    if(mess[i].failGame){
      setFailer(1);
    }else if(mess[i].unFailGame){
      setFailer(0);
    }
    if(mess[i].pChoiseSet){
      setChoise(mess[i].pChoiseSet);
    }
    let delay;
    if(mess[i].img){
      delay = 3;
    }else if(mess[i].audio){
      delay = 3;
    }else{
      delay = Math.floor(mess[i].text.length / 40);
      if(delay===0) delay=1;
    }
    if(mess[i-1] && mess[i-1].answers){
      await typAnim(delay, mess[i], true);
    }else{
      await typAnim(delay, mess[i], false);
    }
delay=0;
setMessNum(i+1);
if(mess[i].returnToQuestion){
  returnToQuestion(mess[i].returnToQuestion);
  break;
}
await waitin();
if(mess[i].answers){
  break;
}
if(mess[i].endOfChat){
  go();
  break;
}
if(mess[i].skipAnswers){
  answered=undefined;
}
  }
}


async function returnToQuestion(item){
  answered=undefined;
  answArr.splice(answArr.indexOf(item), 1);
  setAnswArr(prev => [...answArr]);
  if(answArr.length>0){
  setMessNum(16);
  await typAnim(3, {text:"What's next?",from:'messageFromHer', answers:answArr});
  }else{
  start(messNum);
}
}

function changeOpacity(toLow){
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
  if(toLow){
    if(op>0){
      op-=0.1;
    setOpacity(op);
    setTimeout(ChangetoLow, 20);
  }else{
    setAnswers(undefined);
    return;
  }
}else{
  if(op<1){
    op+=0.1;
  setOpacity(op);
  setTimeout(change, 20);
}else{
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
}
  function typAnim(end,message, afterAnswers){
    return new Promise((resolve, reject) => {
    let i=0,j=0;
    if(message.img && message.gallery){
      if(gallery.has(message.img)){
        if(gallery.get(message.img) !== "1"){
        newGallery.set(message.img, '1');
        if(isLS){
        localStorage.setItem('gallery', JSON.stringify(Array.from(newGallery.entries())));
      }
        setGallery(newGallery);
      }
      }
    }
    if(message.from === 'messageFromMe'){
      j=end;
    }else{
      document.getElementById("wrap").onclick=endAnim;
      function endAnim(){
          j=end;
        }
    }
    anim();
    async function anim(){
      try{
      if(j===end){
        if(!message.audio && !afterAnswers){
          setVolumeEffects(0.1);
          playEffects(messageSound, false);
        }
      setMessage((prev) => [...prev, message]);
        if(message.answers){
          setIndexWrap(14);
          document.getElementById('typ').innerHTML = "Online";
          setAnswers(message.answers);
          await waitin();
          answer0.current.style.transform = "translateX("+document.body.clientWidth+"px)";
          answer1.current.style.transform = "translateX("+(-1*document.body.clientWidth)+"px)";
          setOpacity("flex");
          await changeSetting(answer0,"current.style.transform", 0, "translateX", 14);
          await changeSetting(answer0,"current.style.transform", document.body.clientWidth*-0.12, "translateX", 3);
          changeSetting(answer0,"current.style.transform", 0, "translateX", 3);
          await changeSetting(answer1,"current.style.transform", 0, "translateX", 12);
          await changeSetting(answer1,"current.style.transform", document.body.clientWidth*0.12, "translateX", 3);
          await changeSetting(answer1,"current.style.transform", 0, "translateX", 2);
          answersAppeared.current = true;
        }
        /*if(message.endOfChat){
          if(message.endOfChat.skip){
            if(message.endOfChat.move){
              setMoveTo(message.endOfChat.move);
            }
            setTimeout(setNextOnIWithDelay, 2000)
          }else{
          setTimeout(setNextWithDelay, 2000)
          }
        }
        function setNextOnIWithDelay(){
          setIndexWrap(14);
          setNextOnI({text: message.endOfChat.text});
        }
        function setNextWithDelay(){
          setIndexWrap(14);
          setNext({text: message.endOfChat.text});
        }*/
        document.getElementById('typ').innerHTML = "Online";
          resolve()
          return;

        }
      if(i===0){
        if(message.img){
    document.getElementById('typ').innerHTML = "sending a photo...";
  }else if(message.audio){
    document.getElementById('typ').innerHTML = "recording an audio...";
  }else{
    document.getElementById('typ').innerHTML = "typing...";
  }
  i++;
    setTimeout(anim,200);
  return;
}
if(i===1){
  if(message.img){
    document.getElementById('typ').innerHTML = "sending a photo.";
  }else if(message.audio){
    document.getElementById('typ').innerHTML = "recording an audio.";
  }else{
    document.getElementById('typ').innerHTML = "typing.";
  }
i++;
  setTimeout(anim,200);
    return;
}
if(i===2){
  if(message.img){
    document.getElementById('typ').innerHTML = "sending a photo..";
  }else if(message.audio){
    document.getElementById('typ').innerHTML = "recording an audio..";
  }else{
    document.getElementById('typ').innerHTML = "typing..";
  }
  j++;
  i=0;
    setTimeout(anim,200);
  return;
}
}catch(e){
  console.log(e);
}
}
});
  }

  function changeSetting(obj, setting, changeTo, um, speed, char, float, stopLoading){
    speed=speed*2.3*hzAdjuster;
    return new Promise((resolve, reject) => {
      const props = setting
          .split(/[./[\]]/g)
          .filter(p => p);
      const prop = props.pop();
      const parent = props.reduce((result, key) => result[key], obj);
      var i;
      if(setting == "current.style.transform" || setting == "style.transform"){
        if(float){
          i = parseFloat(parent[prop].split("(")[1].split(")")[0]);
        }else{
          i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
        }
      }else if(setting == "current.style.transform" || setting == "style.transform" && um == "translateX"){
        if(float){
          i = parseFloat(parent[prop].split("(")[1].split("px)")[0]);
        }else{
          i = Math.round(parseFloat(parent[prop].split("(")[1].split("px)")[0]));
        }
      }else if(setting == "current.style.filter" || setting == "style.filter"){
        if(float){
          i = parseFloat(parent[prop].split("(")[1].split("px)")[0]);
        }else{
          i = Math.round(parseFloat(parent[prop].split("(")[1].split("px)")[0]));
        }
      }else{
        if(float){
        i = parseFloat(parent[prop]);
        }else{
        i = Math.round(parseFloat(parent[prop]));
        }
      }
      let slowDownTrigger = 0;
      let slower = 8;
      change();
    function change(){
      if(i>changeTo){
        i-=speed;
        if(i<=changeTo){
          i = changeTo;
          if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
            parent[prop] = "scale("+i+")";
          }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
            parent[prop] = "rotateY("+i+"deg)";
          }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateX"){
            parent[prop] = "translateX("+i+"px)";
          }else if((setting == "current.style.filter" || setting == "style.filter")){
            parent[prop] = "blur("+i+"px)";
          }else{
            parent[prop] = i+um;
          }
          resolve();
          return;
        }
    }else if(i<changeTo){
      i+=speed;
      if(i>=changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateX"){
          parent[prop] = "translateX("+i+"px)";
        }else if((setting == "current.style.filter" || setting == "style.filter")){
          parent[prop] = "blur("+i+"px)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
    }else{
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateX"){
        parent[prop] = "translateX("+i+"px)";
      }else if((setting == "current.style.filter" || setting == "style.filter")){
        parent[prop] = "blur("+i+"px)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateX"){
      parent[prop] = "translateX("+i+"px)";
    }else if((setting == "current.style.filter" || setting == "style.filter")){
      parent[prop] = "blur("+i+"px)";
    }else{
      parent[prop] = i+um;
    }
  requestAnimationFrame(change);
  return;
  }
  });
  }

  return (
<div className='wrap'>
{next && <div className='nextDay' onClick={go}><p>{next.text}</p></div>}
{nextOnI && <div className='nextDay' onClick={goOnI}><p>{nextOnI.text}</p></div>}
<div className='clickWrap' id='wrap' style={{opacity:white,zIndex:indexWrap}} ></div>
{/*<div className='nextDay'><p>NEXT DAY ></p></div>
<div className='type'><input type='text' placeholder='Type ur name' onChange={onChange}/> </div>*/}
{ answers &&
<div className='answers' style={{display:opacity}}>
{answers.map((item,index)=>{
  return (
    <>
    <div className='answer' ref={eval("answer"+index)} style={{transform: "translateX(0px)"}} name={index} key={index}><div className="answerCover" onClick={myAnswer} value={item} name={index}></div>{item.img? <img src={item.img} height="100px"/> : <input type="text" onClick={myAnswer} disabled={true} readOnly id="icon" value={item}/>}</div>
    </>
  )
})}
</div>
}
<div className='bgPic' style={{backgroundImage:"url("+chatBG+")"}}></div>
<div className='topLine'>
<div className="arrow1" onClick={goToMenu}>
    <div></div>
</div>
<div className='pict'>
  <img className='img' src={from.photo} alt="" />
</div>
<div>
<p className='name'>{from.name}</p>
<p className='typ' id="typ">{textTranslation[language]["online"]}</p>
</div>

</div>
<div id='back'></div>
<div className='messages' id='messages'>
{ messages.map(function (item, index) {
return(
  <div className={item.audio || item.fake? item.from+'Audio':item.from} key={index}>
  <div className={item.from+'Under'}></div>
  {item.text && <p className="comment_text">{item.text}</p>}
  {item.img && <img src={item.img} height={item.height} max-width='100%'/>}
  {item.audio && <><div className='angle lefttop'></div><div className='angle leftbottom'></div><div className='angle rightbottom'></div><div className='angle righttop'></div><audio id="audio" src={item.audio} controls autoPlay></audio></>}
  </div>
);

})
}
</div>
</div>
  );
}

export default Chat;
